export enum UserRole {
    ADMIN = 8,
    ORIGINATOR = 3,
    PUBLISHER = 4,
    CUSTOMER = 7
}
